import React from "react";
import notfound from "../../assets/images/not_found.svg";
import { styled } from "@mui/material/styles";

const NotFoundMain = styled("div")(({ theme, center, MT, IconWidth }) => ({
  textAlign: center ? "center" : "",
  marginTop: MT ? MT + "px" : "",
  "& img": {
    height: "auto",
    width: IconWidth ? IconWidth + "%" : "20%",
    opacity: "0.3",
  },
}));

const NotFoundIcon = ({ center = true, MT, IconWidth }) => {
  return (
    <>
      <NotFoundMain center={center} MT={MT} IconWidth={IconWidth}>
        <img src={notfound} alt="not found image" />
      </NotFoundMain>
    </>
  );
};

export default NotFoundIcon;
